module.exports = __webpack_public_path__ + "img/dinersclub.c46530f7.png";